import { cn } from 'lib/utils';
import { splitTextPreviewLines } from '../utils/assistant-file-preview';

type AssistantTextPreviewProps = {
  content: string;
  className?: string;
};

/** Claude-style plain TXT preview: monospace body + line-number gutter. */
export const AssistantTextPreview = ({ content, className }: AssistantTextPreviewProps) => {
  const lines = splitTextPreviewLines(content);
  const gutterWidthCh = Math.max(String(lines.length).length, 2);

  return (
    <div className={cn('h-full w-full overflow-auto bg-background', className)}>
      <div className="min-w-full px-3 py-4 md:px-5">
        <pre className="m-0 font-mono text-[13px] leading-6 text-foreground">
          {lines.map((line, index) => (
            <div key={`line-${index}`} className="flex min-w-0">
              <span
                aria-hidden
                className="shrink-0 select-none pr-4 text-right text-muted-foreground/70"
                style={{ width: `${gutterWidthCh + 1}ch` }}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1 whitespace-pre-wrap break-words">{line || ' '}</span>
            </div>
          ))}
        </pre>
      </div>
    </div>
  );
};
